import { fetchGet } from './api';
import { IAcademy } from '../types/academy.type';

export const fetchAcademies = () => fetchGet<IAcademy[]>('academies');
